import { mapTemplateType, mapTemplateTypes, TemplateType } from "./TemplateType";

export interface MaterialTemplateCategoryType {
    id: number;
    category_name: string | null;
    path: string | null;
    for: 'Area' | 'Volume';
    status: 1 | 0;
    created_by: number | null;
    selectedTemplate: TemplateType | null,
    template_data: TemplateType[];
}

// to single object maping
export const mapMaterialTemplateCategoryType = (data: any): MaterialTemplateCategoryType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const materialTemplateCategoryType: MaterialTemplateCategoryType = {
        id: data.id,
        category_name: data.category_name || null,
        path: data.path || null,
        for: data.for,
        status: data.status,
        created_by: data.created_by || null,
        selectedTemplate: data.selectedTemplate !== null ? mapTemplateType(data.selectedTemplate) : null,
        template_data: Array.isArray(data.template_data) ? mapTemplateTypes(data.template_data) : [],
    }

    return materialTemplateCategoryType;
}

// maping list objects
export const mapMaterialTemplateCategoryTypes = (data: any[]): MaterialTemplateCategoryType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapMaterialTemplateCategoryType);
}